var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6396 2.77645C17.3935 -0.665892 22.5293 -0.951081 25.6465 2.1661C28.4383 4.95788 28.5445 9.45075 25.8887 12.3722L14.8301 24.5352C14.5932 24.7958 14.2574 24.9444 13.9053 24.9444C13.5532 24.9444 13.2173 24.7958 12.9805 24.5352L1.92383 12.3722C-0.731996 9.45075 -0.625714 4.95787 2.16602 2.1661C5.28331 -0.95119 10.4181 -0.665775 13.1719 2.77645L13.9053 3.69345L14.6396 2.77645ZM23.8779 3.93466C21.8144 1.87109 18.4149 2.05914 16.5918 4.33798L14.8828 6.47567C14.6457 6.77228 14.286 6.94531 13.9063 6.9454C13.5266 6.9454 13.1679 6.77209 12.9307 6.47567L11.2197 4.33798C9.3965 2.05931 5.99794 1.87129 3.93457 3.93466C2.08644 5.78283 2.01531 8.75657 3.77344 10.6905L13.9053 21.836L24.0391 10.6905C25.7972 8.75655 25.7261 5.78281 23.8779 3.93466Z",
    fill: "#253FF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.3b10e67c903de4cbbe7f67364de1b891.svg";
export { ForwardRef as ReactComponent };